// src/locales/en/forms.js
export const forms = {
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    nameRequired: "Name is required",
    invalidEmail: "Please enter a valid email",
    fieldRequired: "This field is required",
    savingChanges: "Saving changes...",
    changesSaved: "Changes saved successfully",
    errorSaving: "Error saving changes"
}